import React from "react";
import autoBind from 'react-autobind';
import { Layout, Form, Row, Col, Select, Button, message, Typography } from 'antd';
import PageHeader from '@/components/PageHeader/PageHeader';
import DatePicker from '@/components/DatePicker/DatePicker';
import { GrDocumentPdf, GrDocumentExcel } from "react-icons/gr";
import moment from 'moment';
//
import CustomComponent from '@/components/CustomComponent';
import WhiteBox from '@/views/commonComponents/WhiteBox';
import CommonLoadingView from '@/views/commonComponents/CommonLoadingView';
//
import config from "@/config/config";
import Utils from "@/components/Utils";
import Globals from '@/config/Globals';
//
export default class AdminMemberTaxReport extends CustomComponent {
  constructor(props) {
    super(props);
    autoBind(this);
    this.state = { isLoading: false };
  }

  //Live cycle
  componentDidMount() { document.title = `${config.ApplicationName} - Tax Receipts`; }

  //Actions
  async handleSubmit() {
    const formData = await this.form.validateFields();

    if (formData) {
      const duesPaidThru = formData.duesPaidThru ? moment(formData.duesPaidThru).format(Globals.DefaultAPIDateFormat) : null;
      this._generate({ duesPaidThru });
    }
  }

  //UI
  render() {
    return (
      <Layout.Content className="pageContent">
        <CommonLoadingView isLoading={this.state.isLoading} isFixed />
        <PageHeader title="Export Tax Receipts Data" extra={[<Button key="1" onClick={this.handleSubmit} type='primary'>Generate Report</Button>]} />
        <Layout.Content>
          <WhiteBox>
            <Form layout="vertical" {...Utils.propagateRef(this, 'form')}>
              <Row>
                <Col span={4}>
                  <Typography.Text strong> Exporting tax receipt data for: </Typography.Text>
                  <Typography.Text> {this.props.app.sharedCache()?.getConfig()?.settings?.postingYear || 'N/A'} </Typography.Text>
                </Col>
              </Row>
            </Form>
          </WhiteBox>
        </Layout.Content>
      </Layout.Content>
    )
  }

  /* private API */
  async _generate(data) {
    this.startLoading();
    //request
    const resp = await this.props.app.api.reports.membersTaxReceipts(data);
    if (!this._isMounted) return;
    if (resp.statusCode == 200 && resp.body) {
      Utils.downloadBlob(resp.body, `Member Tax Receipts - ${moment(new Date()).format('MMYY')}`, 'xlsx');
    } else {
      this.props.app.alertController.showAPIErrorAlert(null, resp);
    }
    this.setState({ isLoading: false });
  }
}
